// @flow

export default class POSType {

  static POS_DEMO = '';

  static POS_CASHPAD = 'cashpad';

  static POS_CSI = 'csi';

  static POS_IKENTOO = 'ikentoo';

  static POS_ORCHESTRA = 'orchestra';

  static POS_ORCHESTRA_V2 = 'orchestra-v2';

  static POS_PAYMYTABLE = 'paymytable';

  static POS_TILLER = 'tiller';

  static POS_TCPOS = 'tcpos';
  static POS_TCPOS_7_1 = 'tcpos7.1';
  static POS_TCPOS_7_4 = 'tcpos7.4';

  static POS_ZELTY = 'zelty';

  static POS_SEQUOIASOFT = 'sequoiasoft';

  static POS_ORACLE = 'oracle';

  /**
   * @return array
   */
  static getChoices(): Array<Object> {
    return [
      {
        label: 'PayMyTable',
        value: POSType.POS_PAYMYTABLE,
        deprecated: false,
      },
      {
        label: 'Tcpos 7.4+',
        value: POSType.POS_TCPOS_7_4,
        deprecated: false,
      },
      {
        label: 'Tcpos 7.1',
        value: POSType.POS_TCPOS_7_1,
        deprecated: false,
      },
      {
        label: 'Tcpos < 7.1',
        value: POSType.POS_TCPOS,
        deprecated: false,
      },
      {
        label: 'Demo',
        value: POSType.POS_DEMO,
        deprecated: false,
      },

        // deprecated values
      {
        label: 'Cashpad',
        value: POSType.POS_CASHPAD
        ,
        deprecated: true,
      },
      {
        label: 'CSI - CashSystemes',
        value: POSType.POS_CSI,
        deprecated: true,
      },
      {
        label: 'Ikentoo',
        value: POSType.POS_IKENTOO,
        deprecated: true,
      },
      {
        label: 'Oracle',
        value: POSType.POS_ORACLE,
        deprecated: true,
      },
      {
        label: 'Orchestra',
        value: POSType.POS_ORCHESTRA,
        deprecated: true,
      },
      {
        label: 'Orchestra v2',
        value: POSType.POS_ORCHESTRA_V2,
        deprecated: true,
      },

      {
        label: 'SequoiaSoft',
        value: POSType.POS_SEQUOIASOFT,
        deprecated: true,
      },
      {
        label: 'Tiller',
        value: POSType.POS_TILLER,
        deprecated: true,
      },



      {
        label: 'Zely',
        value: POSType.POS_ZELTY,
        deprecated: true,
      }
    ];
  }
}
